import { render, staticRenderFns } from "./input-contragent.vue?vue&type=template&id=654a824d"
import script from "./input-contragent.vue?vue&type=script&lang=js"
export * from "./input-contragent.vue?vue&type=script&lang=js"
import style0 from "./input-contragent.vue?vue&type=style&index=0&id=654a824d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports